import { Component, OnInit,ViewChild  } from '@angular/core';
import {  NavController, NavParams,ToastController,LoadingController,ViewController,AlertController,Content  } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DTOObterLote } from '../../dto/dtoObterLote';
import { LoteDAO } from '../../daos/lote-dao';
import { DefeitoLote} from '../../entities/defeito-lote';
import { RecebeLote } from '../../entities/recebe-lote';
import { DefeitoGrupo } from '../../entities/defeito-grupo';
import { DefeitoTipo } from '../../entities/defeito-tipo';
import { Usuario } from '../../entities/usuario';

@Component({
  selector: 'page-revisar-lote-novo',
  templateUrl: 'revisar-lote-novo.html',
})

export class RevisarLoteNovoPage implements OnInit {
  @ViewChild(Content) content: Content;
  public dtoObterLote: DTOObterLote;
  public defeitoLote: DefeitoLote = new DefeitoLote();
  public recebeLote: RecebeLote = new RecebeLote();
  public usuario: Usuario; 

  public defeitoRetrabalhoGrupo: DefeitoGrupo[] = [];
  public defeitoRetrabalhoTipo: DefeitoTipo[] = [];
  public defeito2qGrupo: DefeitoGrupo[] = [];
  public defeito2qTipo: DefeitoTipo[] = [];
  defeitoLoteRetrabalho: DefeitoLote[] = [];
  defeitoLote2Qualidade: DefeitoLote[] = [];
  
  calcQtde1Qualidade: number;
  teveAlteracao: boolean = false;
  public typeSegmento: string; 
  

  adicionarRetrabalhoForm: FormGroup;
  adicionar2QualidadeForm: FormGroup;

  constructor(public navCtrl: NavController,_navParams: NavParams,
    _formBuilder: FormBuilder,
    private _loteDAO: LoteDAO,
    public navParams: NavParams,
    private _viewCtrl: ViewController,
    private _alertCtrl: AlertController,
    private _loadingCtrl: LoadingController,
    private _toastCtrl: ToastController) {
      this.dtoObterLote = _navParams.get('dtoObterLote');
      this.usuario = _navParams.get('usuario');  
      this.adicionarRetrabalhoForm = _formBuilder.group({
        qtdeRetrabalho: ['', Validators.required], 
        gpDefeitoRetrabalho: ['', Validators.compose([Validators.required])],    
        tpDefeitoRetrabalho: ['', Validators.compose([Validators.required])]
      });

      this.adicionar2QualidadeForm = _formBuilder.group({
        qtdeSegQualidade: ['', Validators.required], 
        gpDefeitoSegQualidade: ['', Validators.compose([Validators.required])],    
        tpDefeitoSegQualidade: ['', Validators.compose([Validators.required])]
      });
  }

  ngOnInit(): void {
    this.typeSegmento = '1';
    this.recebeLote = this.dtoObterLote.RecebeLote; 
    this.calcQtde1Qualidade = this.dtoObterLote.Quantidade - this.dtoObterLote.QtdeTotDefeitoSegQualidade - this.recebeLote.QtdeIrrecuperavel;
       
    
    if (this.dtoObterLote.DefeitoLote !== null){
      this.defeitoLoteRetrabalho = this.dtoObterLote.DefeitoLote.filter(a => a.Tipo == 'R');  
      this.defeitoLote2Qualidade = this.dtoObterLote.DefeitoLote.filter(a => a.Tipo == 'S'); 
    }


    
    
    let load = this._loadingCtrl.create({ content: 'Obtendo grupos e tipos...' });
    load.present();
    Promise.all([
        this._loteDAO.obterDefeitoGrupo(this.dtoObterLote.RecebeLote.Empresa.Id)
    ]).then(res => {
        this.defeito2qGrupo = res[0];        
        this.defeitoRetrabalhoGrupo = res[0];  
        load.dismiss();
    }).catch(error => {
        this._toastCtrl.create({
            message: 'Ocorreu um erro ao tentar obter os grupos e os tipos. Tente novamente!'+error,
            duration: 3000
        }).present();
        load.dismiss();
    });
  }


  //public selDefeito2qGrupo(idDefeitoGrupo: any) {    
  //    this.defeito2qTipo = [];  
  //    this.defeito2qTipo = this.defeito2qGrupo.filter((item) => { return item.Id == idDefeitoGrupo })[0].DefeitoTipo;      
  //}

  public selDefeitoGrupoRetrabalho(idDefeitoGrupo: any) {  
    if (idDefeitoGrupo.length > 0) {
      this.defeitoRetrabalhoTipo = [];  
      this.defeitoRetrabalhoTipo = this.defeitoRetrabalhoGrupo.filter((item) => { return item.Id == idDefeitoGrupo })[0].DefeitoTipo;    
    }
  }


  public selDefeitoGrupo2Qualidade(idDefeitoGrupo: any) {  
    if (idDefeitoGrupo.length > 0) {  
      this.defeito2qTipo = [];  
      this.defeito2qTipo = this.defeito2qGrupo.filter((item) => { return item.Id == idDefeitoGrupo })[0].DefeitoTipo;
    }
  }

  public fechar(): void {
    if (!this.dtoObterLote.RecebeLote.DataRevisao) {
      this._alertCtrl.create({ 
        title: 'Deseja registrar a data da inspeção?', 
        subTitle: 'Após registrar a data, o botão liberar lote será habilidato',
        buttons: [
          {
            text: 'Não',            
            handler:() =>{this._viewCtrl.dismiss(this.teveAlteracao)}
          },
          {
            text: 'Sim', 
            handler:() =>{
              this.salvar('Data da Inspeção foi gravada com sucesso!');
              this._viewCtrl.dismiss(true);
            }
          }       
        ] 
      }).present();

    } else  this._viewCtrl.dismiss(this.teveAlteracao);
  }
  
  public salvar(msg: string): void {
      let load = this._loadingCtrl.create({ content: 'Verificando...' });
        load.present();
      this._loteDAO.manterInspecaoLote(this.recebeLote).then(() => {
          load.dismiss().then(() => {
            if (!this.dtoObterLote.RecebeLote.DataRevisao)
              this.dtoObterLote.RecebeLote.DataRevisao = new Date();
              this.teveAlteracao = true;
              this._toastCtrl.create({                               
                  message: msg,
                  duration: 3000
              }).present()
          });
      }).catch((erro) => {
          load.dismiss();
          this._toastCtrl.create({
              message: 'Não foi possível salvar, tente novamente!'+erro,
              duration: 3000
          }).present();
      }); 
  }

  public adicionar2Qualidade(): void {
    if (this.adicionar2QualidadeForm.invalid) {
      this._toastCtrl.create({
          message: 'O formulário está invalido. Favor Verifique!',
          duration: 3000
      }).present();
      return;
    }

    if (this.adicionar2QualidadeForm.valid) {  
      this.defeitoLote.Qtde = this.adicionar2QualidadeForm.get('qtdeSegQualidade').value;
      this.defeitoLote.DefeitoGrupo = this.defeito2qGrupo.find(a => a.Id == this.adicionar2QualidadeForm.get('gpDefeitoSegQualidade').value);  
      this.defeitoLote.DefeitoTipo = this.defeito2qTipo.find(a => a.Id == this.adicionar2QualidadeForm.get('tpDefeitoSegQualidade').value); 
      this.defeitoLote.RecebeLote =  this.recebeLote; 
      this.defeitoLote.Tipo = 'S';   
      this.defeitoLote.Usuario = this.usuario;  

      this._loteDAO.inspecaoNovoLote(this.defeitoLote).then(defeitoLote => {  
        if (!this.dtoObterLote.RecebeLote.DataRevisao)
              this.dtoObterLote.RecebeLote.DataRevisao = new Date();      
        this.defeitoLote2Qualidade.push(defeitoLote);    
        this.teveAlteracao = true;          
      });


      this.adicionar2QualidadeForm.reset();
      //this.adicionar2QualidadeForm.setValue({
      //  qtdeSegQualidade: '',
      //  tpDefeitoSegQualidade:'',
      //  gpDefeitoSegQualidade: '1'
      // });  

    }  
  }

  
  public adicionarRetrabalho(): void {
    if (this.adicionarRetrabalhoForm.invalid) {
      this._toastCtrl.create({
          message: 'O formulário está invalido. Favor Verifique!',
          duration: 3000
      }).present();
      return;
    }

    if (this.adicionarRetrabalhoForm.valid) {  
      this.defeitoLote.Qtde = this.adicionarRetrabalhoForm.get('qtdeRetrabalho').value;
      this.defeitoLote.DefeitoGrupo = this.defeitoRetrabalhoGrupo.find(a => a.Id == this.adicionarRetrabalhoForm.get('gpDefeitoRetrabalho').value);  
      this.defeitoLote.DefeitoTipo = this.defeitoRetrabalhoTipo.find(a => a.Id == this.adicionarRetrabalhoForm.get('tpDefeitoRetrabalho').value); 
      this.defeitoLote.RecebeLote =  this.recebeLote; 
      this.defeitoLote.Tipo = 'R'; 
      this.defeitoLote.Usuario = this.usuario;   
             
      this._loteDAO.inspecaoNovoLote(this.defeitoLote).then(defeitoLote => {
        
        if (!this.dtoObterLote.RecebeLote.DataRevisao)
              this.dtoObterLote.RecebeLote.DataRevisao = new Date();        
        this.defeitoLoteRetrabalho.push(defeitoLote);  
        this.teveAlteracao = true;            
      });

                
      this.adicionarRetrabalhoForm.reset();
      //this.adicionarRetrabalhoForm.setValue({
        //qtdeRetrabalho: '',
        //tpDefeitoRetrabalho:'',
        //gpDefeitoRetrabalho: '1'        
      //});  

    }  
  }

  removeRegistro(defeitoLote){   
    this._loteDAO.removerDefeito(defeitoLote.Id).then(() => {
      if (defeitoLote.Tipo=='R'){
        let index = this.defeitoLoteRetrabalho.indexOf(defeitoLote);     
        this.defeitoLoteRetrabalho.splice(index, 1)
      } 
      else if (defeitoLote.Tipo=='S') {
        let index = this.defeitoLote2Qualidade.indexOf(defeitoLote);   
        this.defeitoLote2Qualidade.splice(index, 1);
        this.dtoObterLote.QtdeTotDefeitoSegQualidade = this.dtoObterLote.QtdeTotDefeitoSegQualidade  - defeitoLote.Qtde;

        this.calcQtde1Qualidade = this.dtoObterLote.Quantidade 
                            - this.dtoObterLote.QtdeTotDefeitoSegQualidade 
                            - this.recebeLote.QtdeIrrecuperavel;
      }  
      this.teveAlteracao = true;          
    });
      
  }

  onChangeRetrabalho(event){
    if (Number(event) < 0 ){
      event = 0; 
      this.adicionarRetrabalhoForm.patchValue({
        qtdeRetrabalho: 0, 
      });
    }
  }

  onChange2Qualidade(event){
    if (Number(event) < 0 ){
      event = 0; 
      this.adicionar2QualidadeForm.patchValue({
        qtdeSegQualidade: 0, 
      });
    }else{

      this.calcQtde1Qualidade = this.dtoObterLote.Quantidade 
                            - this.dtoObterLote.QtdeTotDefeitoSegQualidade 
                            - this.recebeLote.QtdeIrrecuperavel
                            - Number(event) ;


      if (this.calcQtde1Qualidade  < 0){
        this._toastCtrl.create({
        message: 'Quantidade 2º qualidade informada é maior do que o total do lote 1º Qualidade',
        duration: 3000
        }).present();
        this.defeitoLote.Qtde = 0;
        this.calcQtde1Qualidade = this.dtoObterLote.Quantidade 
                            - this.dtoObterLote.QtdeTotDefeitoSegQualidade 
                            - this.recebeLote.QtdeIrrecuperavel;
        this.adicionar2QualidadeForm.patchValue({
          qtdeSegQualidade: 0, 
        });
      }

    }
     

    
     

  }

  onChangeIrrecuperavel(){    
    if (this.defeitoLote.Qtde == undefined)
        this.defeitoLote.Qtde = 0; 

    this.calcQtde1Qualidade = this.dtoObterLote.Quantidade - this.dtoObterLote.QtdeTotDefeitoSegQualidade - 
    (Number(this.defeitoLote.Qtde) +  Number(this.recebeLote.QtdeIrrecuperavel));

   

    if (this.calcQtde1Qualidade  < 0){
      this._toastCtrl.create({
        message: 'Quantidade irrecuperável informada '+this.recebeLote.QtdeIrrecuperavel+' é maior do que o total do lote 1º Qualidade',
        duration: 3000
      }).present();
      this.recebeLote.QtdeIrrecuperavel = 0;

      this.calcQtde1Qualidade = this.dtoObterLote.Quantidade - 
      (Number(this.defeitoLote.Qtde) +  Number(this.recebeLote.QtdeIrrecuperavel));
    }


  }


}



// WEBPACK FOOTER //
// ./src/pages/revisar-lote-novo/revisar-lote-novo.ts